import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { HashRouter, Route, Switch, Redirect, withRouter, useLocation } from "react-router-dom";

// components
import Layout from "./components/Layout/Layout";
// pages
import Error from "./pages/error/Error";
import Login from "./pages/login/Login";
import Logout from "./pages/login/Logout";
import RemoveOldCache from "./removeOldCache";
import { decodeToken, decryptData  } from "./helpers/utility";
// store
import * as actions from "./store/actions/actionIndex";
import TokenLogin from "./pages/login/TokenLogin";
import LDAPLogin from "./pages/login/LDAPLogin";

const App = (props) => {
        const { onTryAutoLogin } = props;
        const [token, setToken] = useState("")
        const location = useLocation();


  useEffect(() => {
   if (!props.isAuthenticated){
      const fetchData = async () => {
        const hashParams = new URLSearchParams(location.hash.split('?')[1]); 
             const myParam = hashParams.get('lt');
               if (myParam) {
                localStorage.setItem("accessToken", myParam);   
                        }
                        const decodedToken = await decryptData();
                        if (decodedToken) {
                        const getToken =   localStorage.getItem("accessToken")
                           setToken(getToken);
                         await props.onAuth(decodedToken.email, "", "", "", 0);
                            }
                    }
                 fetchData();
                }
            }, [props.isAuthenticated, props.responseCode]);

            
            
            useEffect(() => {
               const  checkForExpiredTokens = async()=>{
                const decodedToken = await decodeToken();
                if (decodedToken) {
                    const currentTime = Math.floor(Date.now() / 1000); 
                    if (currentTime > decodedToken.exp) {
                        console.log("jwttoken is expired")
                        localStorage.clear("accessToken");
                        props.onLogout(props.agentId);
                        window.web_logout();
                      window.location.href = decodedToken.logoutURL;

                    }
                }
        }
        checkForExpiredTokens();
            }, []);

            useEffect(() => {
                onTryAutoLogin();
            }, [onTryAutoLogin]);



        let routes = (
                <Switch>
                        {
                       token ? (
                        <>
                         <Route exact path="/" render={() => <Redirect to="/app" />} />
                        <Route path="/app" render={() => <Redirect to="/app" />} />
                        <Route path="/login" render={() => <Redirect to="/app" />} />
                            <Route path="/app" component={TokenLogin} />
                            <Route path="/logout" render={() => <Redirect to="/login" />} />
                           
                        </>
                    ) : ( 
                        <>
                            <Route path="/logout" render={() => <Redirect to="/login" />} />
                           
                            <Route exact path="/" render={() => <Redirect to="/login" />} />
                        <Route path="/app" render={() => <Redirect to="/login" />} />
                        {
                        window.Configs.ladp_login === 1 ?  
                        <Route path="/login" component={LDAPLogin} /> :   
                        <Route path="/login" component={Login} />
                          }
                        </>
                        
                    )
                        }
                        <Route component={Error} />
                </Switch>
        );
        // console.log(setToken)
        if (props.isAuthenticated) {
                routes = (
                        <Switch>
                                <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
                                <Route exact path="/app" render={() => <Redirect to="/app/dashboard" />} />
                                <Route path="/app" component={Layout} />
                                <Route path="/login" render={() => <Redirect to="/app/dashboard" />} />
                                <Route path="/logout" component={Logout} />
                                <Route component={Error} />
                        </Switch>
                );
        }
        //return <HashRouter>{routes}</HashRouter>;

        return (
                <RemoveOldCache>
                        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                                if (loading) return null;
                                if (!loading && !isLatestVersion) {
                                        // You can decide how and when you want to force reload
                                        refreshCacheAndReload();
                                }
				return <HashRouter>{routes}</HashRouter>;
                        }}
                </RemoveOldCache>
        );
};

const mapStateToProps = (state) => {
        return {
                isAuthenticated: state.agentData.loggedIn,
                agentId: state.agentData.agentId,
        };
};

const mapDispatchToProps = (dispatch) => {
        return {
                onAuth: (email, password, extension, action, session_flag) => dispatch(actions.agentLogin(email, password, extension, action, session_flag)),
                onTryAutoLogin: () => dispatch(actions.checkAgentState()),
                onLogout: (agentId) => dispatch(actions.agentLogout(agentId)),
        };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));

